// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.security-questions-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.security-questions-container .select-row {\n  margin: 10px 0;\n}\n\n.security-questions-container input {\n  max-width: 485px;\n}\n\n.security-questions-container input.no-edit {\n  background-color: var(--lighter-grey);\n  text-align: center;\n  font-weight: bold;\n  font-family: system-ui;\n  font-size: 14px;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
